export const getToolbar = (situation) => {
  switch (situation) {
    case "CRUD":
      return ["Add", "Edit", "Delete"];
    case "CRUD-EXPORT":
      return ["Add", "Edit", "Delete", "PdfExport", "ExcelExport", "CsvExport"];
    case "EXPORT":
      return ["PdfExport", "ExcelExport", "CsvExport", "Print"];
    case "EXCEL":
      return ["ExcelExport", "CsvExport", "Print"];
    case "RUD-EXPORT":
      return [
        "Edit",
        "Delete",
        "PdfExport",
        "ExcelExport",
        "CsvExport",
        "Print",
      ];
    case "MESSAGE-EXPORT":
      return ["SendMessage", "PdfExport", "ExcelExport", "CsvExport", "Print"];
    default:
      return [];
  }
};

export default getToolbar;
